"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
const extendedTypes_1 = require("../types/extendedTypes");
const getCloudProviderFromNodeType = {
  [types_1.NODE_TYPES.RESOURCE]: cloudProvider_1.default.AWS,
  [types_1.NODE_TYPES.ACTION]: cloudProvider_1.default.AWS,
  [types_1.NODE_TYPES.MONITORING]: cloudProvider_1.default.AWS,
  [types_1.NODE_TYPES.Azure_Resource]: cloudProvider_1.default.AZURE,
  [types_1.NODE_TYPES.Azure_Action]: cloudProvider_1.default.AZURE,
  [types_1.NODE_TYPES.Azure_Monitoring]: cloudProvider_1.default.AZURE,
  [types_1.NODE_TYPES.VMWARE]: cloudProvider_1.default.VMWARE,
  [types_1.NODE_TYPES.VMWARE_ACTION]: cloudProvider_1.default.VMWARE,
  [types_1.NODE_TYPES.K8_Resource]: cloudProvider_1.default.Kubernetes,
  [types_1.NODE_TYPES.K8_Action]: cloudProvider_1.default.Kubernetes,
  [types_1.NODE_TYPES.TerraformCloudResource]:
    cloudProvider_1.default.TerraformCloud,
  [types_1.NODE_TYPES.TerraformCloudAction]:
    cloudProvider_1.default.TerraformCloud,
  [types_1.NODE_TYPES.TRIGGER]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.FILTER]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.NOTIFICATION]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.REPORT]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.USER_APPROVAL]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.DELAY]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.HTTP]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.CUSTOM]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.JENKINS]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.WORKFLOW]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.WOLKEN]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.SSH]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.NETWORK]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.WORKFLOW_REPORT]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.THROTTLING]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.ADOPTION]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.Decision]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.Parallel]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.UserDefinedNode]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.DataFormatter]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.DataJoiner]: cloudProvider_1.default.UNKNOWN,
  [types_1.NODE_TYPES.GCP_Resource]: cloudProvider_1.default.GCP,
  [types_1.NODE_TYPES.GCP_Action]: cloudProvider_1.default.GCP
};
exports.default = getCloudProviderFromNodeType;
exports.extendCloudProvider = function(nodeDefinition) {
  getCloudProviderFromNodeType[
    extendedTypes_1.getUserDefinedNodeType(
      types_1.NODE_TYPES.UserDefinedNode,
      nodeDefinition.id
    )
  ] = cloudProvider_1.default.UNKNOWN;
};
//# sourceMappingURL=cloudProviderFromNodeTypes.js.map
